export function getStorage( key ) {
	try {
		return localStorage.getItem( key )
	} catch ( e ) {}
}

export function setStorage( key, val ) {
	try {
		localStorage.setItem( key, val )
	} catch ( e ) {}
}
